import React, { Component } from 'react'
import { Grid } from '@softwaredev_cegeka/stix-core'

import './footer.scss'

class Footer extends Component {
    render() {
        let name = 'Your name'
        let email = 'email@company.com'
        return (
            <footer>
                <Grid.Container>
                    <Grid.Row>
                        <Grid.Col md={8}>
                            <div className="contact-data-container">
                                <img
                                    alt="Avatar"
                                    src="https://picsum.photos/70"
                                    className={'contact-img'}
                                />
                                <div className={'contact-data-group'}>
                                    <h1 className={'contact-title'}>
                                        Your contact
                                    </h1>
                                    <ul className={'contact-data'}>
                                        <li>{name}</li>
                                        <li>+32 456 67 67 67</li>
                                        <li>
                                            <a href="mailto:">{email}</a>
                                        </li>
                                    </ul>
                                    <span className={'contact-function'}>
                                        Service Delivery Manager
                                    </span>
                                </div>
                            </div>
                        </Grid.Col>
                        <Grid.Col md={4}>
                            <span className={'service-desk-contact'}>
                                <span>SERVICEDESK </span>
                                <span className={'phone'}>+32 11 24 03 63</span>
                            </span>
                        </Grid.Col>
                    </Grid.Row>
                    <span className={'disclaimer'}>
                        ©2020 Cegeka. All rights reserved
                    </span>
                </Grid.Container>
            </footer>
        )
    }
}

export default Footer
